import { AbilityBuilder, Ability } from '@casl/ability';

import { USER_TYPES } from '../constants/enums';

// type Actions = 'manage' | 'create' | 'read' | 'update' | 'delete';
// type Subjects = 'Todo' | Todo | 'all';

const subjectName = (item) => {
  if (!item || typeof item === 'string') {
    return item;
  }
  // eslint-disable-next-line no-underscore-dangle
  return item.__type;
};

export const ability = new Ability([], { subjectName });

export function defineRulesFor(userType, role, clientType) {
  // console.log('UserType and Roles: ', userType, role);
  const { can, rules } = new AbilityBuilder();

  if (userType === USER_TYPES.PROPCOMP) {
    can('is', 'loggedIn');

    can('read', 'userPreferences');
    can('edit', 'userPreferences');

    can('read', 'order');
    can('read', 'orders');
    can('create', 'order');
    can('delete', 'order');
    can('edit', 'order');
    can('search', 'orders');

    can('read', 'company');
    can('read', 'companies');

    can('read', 'timeTrackings');
    can('create', 'timeTracking');
    can('edit', 'timeTracking');
    can('delete', 'timeTracking');

    can('read', 'expenseTrackings');
    can('create', 'expenseTracking');
    can('edit', 'expenseTracking');
    can('delete', 'expenseTracking');

    can('read', 'overview');
    can('read', 'agreements');
    can('read', 'statistics');
    can('read', 'releaseNotes');
    can('create', 'note');
    can('read', 'support');
    can('read', 'templates');

    can('read', 'inspection');
    can('read', 'inspections');
    can('create', 'inspection');
    can('edit', 'inspection');

    can('read', 'tags');
    can('create', 'tag');
    can('connect', 'tag');

    can('read', 'articles');
    can('read', 'priceLists');

    can('read', 'file');

    if (['standard', 'admin'].includes(role)) {
      can('read', 'property');
      can('read', 'properties');

      can('read', 'address');
      can('read', 'addresses');

      can('read', 'structure');
      can('read', 'structures');

      can('read', 'owner');
      can('read', 'owners');
      can('read', 'clientOwnerUser');
      can('read', 'clientOwnerUsers');

      can('finalise', 'order');
      can('resume', 'order');
      can('read', 'otherOrders');

      can('read', 'forms');
      can('create', 'forms');
      can('edit', 'forms');

      can('read', 'project');
      can('read', 'projects');

      can('read', 'invoices');
      can('create', 'invoice');
      can('edit', 'invoice');

      can('create', 'article');
      can('edit', 'article');

      can('delete', 'file');
    }
    if (role === 'admin') {
      can('read', 'users');
      can('read', 'user');
      can('edit', 'user');
      can('create', 'user');
      can('delete', 'user');

      can('edit', 'clientOwnerUser');
      can('delete', 'clientOwnerUser');

      can('read', 'settings');
      can('edit', 'settings');

      can('create', 'address');
      can('edit', 'address');

      can('create', 'property');
      can('edit', 'property');

      can('create', 'structure');
      can('edit', 'structure');

      can('create', 'owner');
      can('edit', 'owner');
      can('activatePortal', 'owner');

      can('create', 'agreements');
      can('edit', 'agreements');
      can('delete', 'agreements');
      can('connect', 'agreements');

      can('edit', 'project');
      can('create', 'project');

      can('read', 'clientIntegrations');
      can('create', 'clientIntegrations');
      can('delete', 'clientIntegrations');

      can('invite', 'newCompany');
      can('delete', 'note');

      can('delete', 'inspection');

      can('delete', 'article');
      can('create', 'priceList');

      can('delete', 'forms');
    }

    if (clientType && clientType === 'admin') {
      can('create', 'company');
      can('edit', 'company');
      can('invite', 'company');
      can('delete', 'company');
      can('create', 'client');
      can('read', 'superAdmin');
      can('read', 'systemMessages');
      can('create', 'systemMessage');
      can('edit', 'systemMessage');
      can('delete', 'systemMessage');
    }
  } else if (userType === USER_TYPES.CONTRACTOR) {
    can('is', 'loggedIn');

    can('read', 'userPreferences');
    can('edit', 'userPreferences');

    can('read', 'contractorOrders');
    can('read', 'contractorOrder');

    can('read', 'overview');
    can('read', 'contractorAgreements');
    can('read', 'contractorRatings');
    can('read', 'releaseNotes');
    can('read', 'support');
    can('read', 'statistics');

    if (['standard', 'admin'].includes(role)) {
      can('read', 'otherOrders');
    }

    if (role === 'admin') {
      can('read', 'contractorUser');
      can('read', 'contractorUsers');
      can('edit', 'contractorUser');
      can('create', 'contractorUser');

      can('read', 'contractorAgreements');
      can('accept', 'contractorAgreements');

      can('delete', 'user'); // Remove?
      can('delete', 'contractorUser');
    }
  } else if (userType === USER_TYPES.OWNER) {
    can('read', 'ownerOverview');
    can('read', 'ownerOrders');
    can('read', 'ownerOrder');
    can('create', 'ownerOrder');
    can('read', 'userPreferences');
    can('edit', 'userPreferences');

    if (role === 'admin') {
      can('read', 'ownerUser');
      can('read', 'ownerUsers');
      can('edit', 'ownerUser');
      can('create', 'ownerUser');
      can('delete', 'ownerUser');
    }
  } else if (userType === USER_TYPES.TENANT) {
    can('read', 'tenantOrder');
  } else if (userType === USER_TYPES.EXTCO) {
    can('read', 'extcoOrder');
    can('read', 'extcoRegister');
  }
  return rules;
}

export function updateRules(userType, role, clientType) {
  const rules = defineRulesFor(userType, role, clientType);
  ability.update(rules);
}
